import { useContext } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import * as whiteLabelConfig from "@utils/whiteLabelConfig";

export default function useWhiteLabelConfig() {
    const { whiteLabel } = useContext(ApplicationContext);

    return {
        isGuestExperienceEnabled: whiteLabelConfig.getGuestExperienceEnabled(whiteLabel),
        isCandyBarEnabled: whiteLabelConfig.getCandyBarEnabled(whiteLabel),
        siteTheme: whiteLabelConfig.getSiteTheme(whiteLabel),
        referralCodeEnabled: whiteLabelConfig.getReferralCodeEnabled(whiteLabel),
        referralPlaceholder: whiteLabelConfig.getReferralPlaceholder(whiteLabel),
        paymentGateway: whiteLabelConfig.getPaymentGateway(whiteLabel),
        isStripeEnabled: whiteLabelConfig.getStripeEnabled(whiteLabel),
        stripePublicKey: whiteLabelConfig.getStripePublicKey(whiteLabel),
    };
}
